import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getUnits, getCumulativeResult } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import Results from '../events/boulder/Results';
import { isCombinedBoulder, isCombinedLead } from '../helper/ClbHelpers';
import { getPhaseRSC, getLongPhaseRSC, getLevelRSC } from 'helpers/rsc'


const ClbBoulderLead  = ({mirs_competition, mirs_rsc, mirs_language, breakPoint}) => {

    // unit in a phase
    let phaseShort = getPhaseRSC(mirs_rsc);
    let filterScheduled = getLevelRSC(mirs_rsc) === 'PHASE' ? 'S' : 'Y'
    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, phaseShort, filterScheduled],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );


    // results of all units belonging to one phase
    let queryArray = [];
    unitsData?.phase?.units?.forEach((unit) => {
        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    // cumulative data
    let phaseLong = getLongPhaseRSC(mirs_rsc);
    const { data: cumulativeData, isError: isErrorCum, isLoading: isLoadingCum } = useQuery({
        queryKey: ['heatsCumulative', mirs_competition, mirs_language, phaseLong],
        queryFn: getCumulativeResult,
        refetchInterval: 5000,
        staleTime: 5000,
        refetchIntervalInBackground: true,
        notifyOnChangeProps: ['data', 'error'],
        onError: (error) =>
            console.error(`Something went wrong: ${error.message}`),
    });
    const results = useQueries(queryArray);

    const isLoading = unitsLoading || results.some(result => result.isLoading) || isLoadingCum;
    const isError = unitsError || results.some(result => result.isError) || isErrorCum;

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    // Clean fake units associated to phase or not started.
    const realData = results.filter(res => res.data.results)

    let data = realData.find(i => isCombinedLead(i?.data?.results?.eventUnitCode))?.data
    let dataBoulder = realData.find(i => isCombinedBoulder(i?.data?.results?.eventUnitCode))?.data

    if (!data) { return <NotAvailable />; }

    return <>
        <Results data={data} extraData={dataBoulder} extraData2={cumulativeData} mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
    </>
}

export default ClbBoulderLead;